import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8,25a3.031,3.031,0,0,1-1.11-.21A11.031,11.031,0,0,1,5,23.72c-.32-.22-.65-.48-1-.77a12.4,12.4,0,0,1-2-2.237V26a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V25Z"/><path d="M29.609,21.2A10.507,10.507,0,0,1,26,13V6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6v8a9.536,9.536,0,0,0,2,6.06,9.644,9.644,0,0,0,1,1.09,9.391,9.391,0,0,0,2.63,1.78A.973.973,0,0,0,8,23H29a1,1,0,0,0,.61-1.8ZM18,15H15v3a1,1,0,0,1-2,0V15H10a1,1,0,0,1,0-2h3V10a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"/><path d="M4,22.95c.35.29.68.55,1,.77a11.031,11.031,0,0,0,1.89,1.07A3.031,3.031,0,0,0,8,25H8a3.031,3.031,0,0,1-1.11-.21A11.031,11.031,0,0,1,5,23.72c-.32-.22-.65-.48-1-.77a12.382,12.382,0,0,1-2-2.24H2A12.42,12.42,0,0,0,4,22.95Z"/>';
export var NoteAddSVG = function NoteAddSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NoteAddSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NoteAddSVG);